(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.getElementById('bayel-moss-lp');
    if (!root) return;

    /* -------- UGC: click to play/pause -------- */
    const cards = root.querySelectorAll('.bm-ugc__card');
    cards.forEach((card) => {
      const video = card.querySelector('[data-ugc-video]');
      const play = card.querySelector('[data-ugc-play]');
      if (!video || !play) return;
      const start = () => {
        cards.forEach((c) => {
          if (c !== card) {
            const v = c.querySelector('video');
            if (v) { v.pause(); }
            c.classList.remove('is-playing');
          }
        });
        video.muted = false;
        video.play().then(() => card.classList.add('is-playing')).catch(() => {
          video.muted = true;
          video.play();
          card.classList.add('is-playing');
        });
      };
      play.addEventListener('click', start);
      video.addEventListener('play', () => card.classList.add('is-playing'));
      video.addEventListener('pause', () => card.classList.remove('is-playing'));
      video.addEventListener('ended', () => card.classList.remove('is-playing'));
    });

    /* -------- Smooth-scroll for ALL internal anchor links (header CTA, hero CTA, drawer, final CTA, footer nav) -------- */
    const orderForm = root.querySelector('.bm-order');
    const localHeader = root.querySelector('.bm-header');
    let flashTimer = null;

    const smoothScrollTo = (target, opts) => {
      const headerH = localHeader ? localHeader.getBoundingClientRect().height : 0;
      const extra = (opts && opts.extra) || 8;
      const rect = target.getBoundingClientRect();
      const y = window.scrollY + rect.top - headerH - extra;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    };

    const flashOrderForm = () => {
      if (!orderForm) return;
      orderForm.classList.remove('is-flash');
      // force reflow so animation replays if user re-clicks CTA
      void orderForm.offsetWidth;
      orderForm.classList.add('is-flash');
      if (flashTimer) clearTimeout(flashTimer);
      flashTimer = setTimeout(() => orderForm.classList.remove('is-flash'), 1600);
    };

    root.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href === '#' || href === '#top') return;
      const target = root.querySelector(href) || document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      smoothScrollTo(target);
      // Close drawer if open
      const drawer = root.querySelector('[data-bm-drawer]');
      const header = root.querySelector('.bm-header');
      if (drawer && !drawer.hasAttribute('hidden')) {
        drawer.setAttribute('hidden', '');
        header && header.classList.remove('is-open');
      }
      // Flash the order form if the anchor targets the order section or the form itself
      if (href === '#lp-order' || href === '#lp-form' || (orderForm && target.contains(orderForm)) || target === orderForm) {
        // wait a bit so the flash starts as the form comes into view
        setTimeout(flashOrderForm, 350);
      }
    });

    /* -------- Same handler for footer links (footer is outside #bayel-moss-lp root) -------- */
    const footerRoot = document.getElementById('bm-footer');
    if (footerRoot) {
      footerRoot.addEventListener('click', (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a) return;
        const href = a.getAttribute('href');
        if (!href || href === '#' || href === '#top') return;
        const target = root.querySelector(href) || document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        smoothScrollTo(target);
        if (href === '#lp-order' || href === '#lp-form' || (orderForm && target.contains(orderForm)) || target === orderForm) {
          setTimeout(flashOrderForm, 350);
        }
      });
    }

    /* -------- Burger toggle -------- */
    const burger = root.querySelector('[data-bm-burger]');
    const drawer = root.querySelector('[data-bm-drawer]');
    const header = root.querySelector('.bm-header');
    if (burger && drawer && header) {
      burger.addEventListener('click', () => {
        const isOpen = !drawer.hasAttribute('hidden');
        if (isOpen) {
          drawer.setAttribute('hidden', '');
          header.classList.remove('is-open');
        } else {
          drawer.removeAttribute('hidden');
          header.classList.add('is-open');
        }
      });
    }

    /* -------- Sticky mobile CTA: hide when Order section is on-screen -------- */
    if (orderForm && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          document.body.classList.toggle('bm-order-in-view', entry.isIntersecting);
        });
      }, { threshold: 0.15 });
      io.observe(orderForm);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
